import gql from 'graphql-tag';
import { CONED_UTILITY_ID } from '../../state-machine/guards';

export const GET_UTILITIES_BY_ZIP = gql`
  query GetUtilitiesByZip($zipCode: String!) {
    utilitiesByZip(zipCode: $zipCode) {
      suggested {
        id
        displayName
        name
        vnmEligible
        url
        autoAddsOnlineAccount
        overrideEmailIsUsername
        shouldCreatePlanBasedOnBillingExperience
      }
    }
  }
`;

export const conEdUtilityMock = {
  autoAddsOnlineAccount: false,
  displayName: 'ConEd',
  id: CONED_UTILITY_ID,
  name: 'ConEd',
  overrideEmailIsUsername: false,
  url: 'https://www.theonion.com/',
  vnmEligible: true,
  shouldCreatePlanBasedOnBillingExperience: false,
};

export const psegNjUtilityMock = {
  autoAddsOnlineAccount: false,
  displayName: 'PSEG NJ',
  id: 2331,
  name: 'PSEG NJ',
  overrideEmailIsUsername: false,
  url: 'https://www.theonion.com/',
  vnmEligible: true,
  shouldCreatePlanBasedOnBillingExperience: true,
};

export const getUtilitiesByZipMock = {
  utilitiesByZip: {
    suggested: [
      {
        autoAddsOnlineAccount: false,
        displayName: 'Oily',
        id: 1,
        name: 'Oily Ollie',
        overrideEmailIsUsername: false,
        url: 'https://www.theonion.com/',
        vnmEligible: true,
        shouldCreatePlanBasedOnBillingExperience: false,
      },
      {
        autoAddsOnlineAccount: false,
        displayName: 'Boily',
        id: 3,
        name: 'Boily Bollie',
        overrideEmailIsUsername: false,
        url: 'https://www.theonion.com/',
        vnmEligible: false,
        shouldCreatePlanBasedOnBillingExperience: false,
      },
      {
        autoAddsOnlineAccount: false,
        displayName: 'Coaly',
        id: 2,
        name: 'Coaly Christie',
        overrideEmailIsUsername: false,
        url: 'https://www.theonion.com/',
        vnmEligible: true,
        shouldCreatePlanBasedOnBillingExperience: false,
      },
      conEdUtilityMock,
      psegNjUtilityMock,
    ],
  },
};

export const getUtilitiesByZipEmptyMock = {
  utilitiesByZip: {
    suggested: [],
  },
};
